import { call, put, takeLatest } from "redux-saga/effects";
import {
  addCategory,
  updateCategory,
  deleteCategory,
} from "../slices/categoriesSlice";
import { setSavingsCategories } from "../slices/sharedSlice";
import { api } from "../utils/api";

function* refreshSavingsCategoriesSaga() {
  try {
    const { data } = yield call(api.getCategories, "savings");

    yield put(setSavingsCategories(data));
    console.log("Savings Categories refreshed:", data);
  } catch (error) {
    console.error("Failed to refresh Savings sources", error);
  }
}

export default function* sharedSaga() {
  yield takeLatest(
    [addCategory.type, updateCategory.type, deleteCategory.type],
    refreshSavingsCategoriesSaga
  );
}
